import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";


interface ModalProps {
    open: boolean;
    onClose: {
        (event: {}, reason: "backdropClick" | "escapeKeyDown"): void
    };
    children: React.ReactNode
}

export default (props: ModalProps) => {
    return (
        <Modal open={props.open} onClose={props.onClose}>
            <Box sx={{
                position: 'absolute' as 'absolute',
                top: '25%',
                left: '50%',
                maxWidth: '450px',
                transform: 'translate(-50%, -25%)',
            }}>
                {props.children}
            </Box>
        </Modal>
    )
}